module.exports = __webpack_public_path__ + "static/media/icon_4.13ab4fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_4.png
// module id = 1898
// module chunks = 0 1